import script from "./CategorieCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategorieCard.vue?vue&type=script&setup=true&lang=ts"

import "./CategorieCard.vue?vue&type=style&index=0&id=069d1472&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069d1472"]])

export default __exports__